module.exports = __webpack_public_path__ + "img/Keyboard-Arrow-Left-Filled-black.64863021.svg";